import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'
import { BugReportButton } from '@/components/bug-report-button'

const reportItems = [
  'Your mail provider and account type',
  'Your operating system and NewEmail version',
  'Whether automatic setup or manual IMAP/SMTP settings were used',
  'A clear description of what happened and what you expected',
  'Any error messages, copied exactly',
]

export default function SupportPage() {
  return (
    <ContentPage
      eyebrow="// support"
      title="Get help or report an issue"
      description="A useful report gets to the cause faster. Here is what to check first and what to include."
    >
      <Prose>
        <Section title="Before you report">
          <p>
            Check the{' '}
            <Link href="/faq" className="text-primary underline underline-offset-4">
              FAQ
            </Link>{' '}
            and confirm your provider’s IMAP access and app-password requirements. For connection
            problems, verify the server host, port, and SSL/TLS setting against your provider’s
            documentation.
          </p>
        </Section>

        <Section title="What to include in a report">
          <ul className="flex flex-col gap-2">
            {reportItems.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </Section>

        <Section title="Report a bug">
          <p>
            Use the form below to send a focused report to the NewEmail team. Do not include
            passwords or private message content.
          </p>
          <BugReportButton />
        </Section>

        <Section title="Still need a hand?">
          <p>
            Ask the community in the{' '}
            <Link href="/forum" className="text-primary underline underline-offset-4">
              NewEmail forum
            </Link>{' '}
            or email{' '}
            <a href="mailto:rick@new-email.net" className="text-primary underline underline-offset-4">
              rick@new-email.net
            </a>
            .
          </p>
        </Section>
      </Prose>
    </ContentPage>
  )
}
